module.exports = __webpack_public_path__ + "static/media/gravity_logo.f38521b7.svg";